module.exports = __webpack_public_path__ + "img/envelope.02cffa62.svg";